import React, { createRef } from "react";
import { INGREDIENTS } from "./getIngredients.ts";

interface AbstractCanvasProps<D> {
    ingredients: INGREDIENTS;
    canvasRef: React.RefObject<HTMLCanvasElement | null>;
    currentChallengeData: D;
}

interface AbstractCanvasState {
}

export abstract class AbstractCanvas<D> extends React.Component<AbstractCanvasProps<D>, AbstractCanvasState> {
    protected canvasRef: React.RefObject<HTMLCanvasElement | null>;
    protected imageRef: React.RefObject<HTMLImageElement | null>;
    constructor(props: AbstractCanvasProps<D>) {
        super(props);
        this.canvasRef = props.canvasRef;
        this.imageRef = createRef();
        this.draw();
    }

    abstract draw(): void;

    componentDidMount(): void {
        this.draw();
        //setTimeout(this.draw, 1000);
        //setTimeout(this.draw, 3000);
        //setTimeout(this.draw, 5000);
        //setTimeout(this.draw, 10000);
    }

    componentDidUpdate(prevProps: Readonly<AbstractCanvasProps<D>>): void {
        console.log(this.props)
        if (prevProps.currentChallengeData !== this.props.currentChallengeData) {
            this.draw();
        }
    }

    render() {
        return <><canvas id="resetCanvas" ref={this.canvasRef}/>
          <img onContextMenu={e=>{e.preventDefault();return false}} ref={this.imageRef} /></>;
    }
}

export type {AbstractCanvasProps, AbstractCanvasState};